var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBreakdown(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "#1A1D24",
    fillOpacity: 0.44,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.83341 5.83333H14.8334V7.5H9.83341V5.83333ZM9.83341 9.16667H14.8334V10.8333H9.83341V9.16667ZM9.83341 12.5H14.8334V14.1667H9.83341V12.5ZM6.50008 5.83333H8.16675V7.5H6.50008V5.83333ZM6.50008 9.16667H8.16675V10.8333H6.50008V9.16667ZM6.50008 12.5H8.16675V14.1667H6.50008V12.5ZM17.4167 2.5H3.91675C3.50008 2.5 3.16675 2.83333 3.16675 3.25V16.75C3.16675 17.0833 3.50008 17.5 3.91675 17.5H17.4167C17.7501 17.5 18.1667 17.0833 18.1667 16.75V3.25C18.1667 2.83333 17.7501 2.5 17.4167 2.5ZM16.5001 15.8333H4.83341V4.16667H16.5001V15.8333Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBreakdown);
export default __webpack_public_path__ + "static/media/breakdown.7cb2024cbef29ed78fdcfaadf2906591.svg";
export { ForwardRef as ReactComponent };